export const VIEWED_EMAIL_CAPTURE_FORM = 'Viewed Email Capture Form';
export const DISMISSED_EMAIL_CAPTURE_FORM = 'Dismissed Email Capture Form';
